import $ from 'jquery';

class Animations {

    constructor() {     
        this.winOffset = 100; // how many pixels from the top and bottom before the animation triggers   
        this.delayBase = 400;
        this.anim_items = $('.animate, .card__title, .home-section__inner h1, .home-section__inner p, .home-section__inner a, .hero__content-heading h1, .content-block--title-columns__copy h3, .content-block--title-columns__copy p');

        const ref = this;

        ref.scrollWindow();
        $(window).on('scroll resize',function(){
            ref.scrollWindow();
        });
    }

    scrollWindow() {
        console.log('anim trigger');
        const win = $(window);
        const winTop = win.scrollTop() + this.winOffset;
        const winBot = winTop + win.outerHeight() - this.winOffset;
        this.anim_items.each(function(index,item){             
            const target = $(item);
            if (!target.hasClass('animated') && !target.hasClass('card--hidden')) {
                const targetTop = target.offset().top;
                const targetBot = targetTop + target.outerHeight();
                if (targetTop > winTop && targetBot < winBot) { // entire item visible
                    target.addClass('almost-animated');
                }
                if (targetTop < winBot && targetBot > winBot) { // top of item visible
                    target.addClass('almost-animated');
                }
                if (targetTop < winTop && targetBot > winTop) { // bottom of item visible
                    target.addClass('almost-animated');
                }
            }
        });  
        const ref = this;
        $('.almost-animated').each(function(index,item){ // assign increasingly higher transition-delay
            const target = $(item);
            target.css('transition-delay',(ref.delayBase + (index * 200))+'ms');           
            target.removeClass('almost-animated').addClass('animated');
        });      
    }
}

module.exports = Animations;